
import { defineComponent, ref, onMounted, PropType, computed } from "vue";
import stc from "string-to-color";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import { useStore, mapGetters } from "vuex";
import statusModel from "@/core/models/share/status.interface";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import inviteAvailableTimeModel from "@/core/models/share/inviteAvailableTime.interface";
import TimelineComponent from "@/components/share/timelineComponent.vue";
import ParticipantModal from "@/components/participant/modal/participantModal.vue";
import {
  IosArrowDown,
  IosArrowBack,
  IosArrowForward,
  MdArrowDropleft,
  MdArrowDropright,
} from "@vicons/ionicons4"; //https://www.xicons.org/#/
import {
  Module as ParticipationModule,
  Actions as ParticipationActions,
  Getters as ParticipationGetters,
} from "@/store/enums/participationEnums";
import {
  Module as HosterModule,
  Actions as HosterActions,
} from "@/store/enums/hosterEnums";
import voteEventModel from "@/core/models/share/voteEvent.interface";
import timelineRowGroupHeaderModel from "@/core/models/share/timeline/rowGroupHeader.interface";
import timelineRowHeaderModel from "@/core/models/share/timeline/rowHeader.interface";
import timelineElmtModel from "@/core/models/share/timeline/timelineItem.interface";

export default defineComponent({
  name: "timelinePage",
  components: {
    IosArrowDown,
    IosArrowBack,
    IosArrowForward,
    MdArrowDropleft,
    MdArrowDropright,
    ParticipantModal,
    TimelineComponent,
  },
  props: {
    caption: { type: String },
    baseDate: { type: Date, default: new Date() },
    showWeek: { type: Number, default: 3 },
    eventStatusHeaders: {
      type: Array as PropType<Array<statusModel>>,
      default: [],
      required: true,
    },
    eventHeaders: {
      type: Array as PropType<Array<inviteEventModel>>,
      default: [],
      required: true,
    },
    eventData: {
      type: Array as PropType<Array<inviteAvailableTimeModel>>,
      default: [],
      required: true,
    },
  },
  setup(props: any, context: any) {
    const store = useStore();
    const showModal = ref(false);
    const modalEventHeaderId = ref<string>("NULL");
    const rowGroupHeaders = computed<Array<timelineRowGroupHeaderModel>>(() =>
      store.getters[
        ParticipationModule.desc +
          ParticipationGetters.TimelineRowGroupHeaderList
      ](props.eventStatusHeaders)
    );
    const rowHeaders = computed<Array<timelineRowHeaderModel>>(() =>
      store.getters[
        ParticipationModule.desc + ParticipationGetters.TimelineRowHeaderList
      ](props.eventHeaders)
    );
    let userResponse = computed<Array<voteEventModel>>(
      () =>
        store.getters[
          ParticipationModule.desc + ParticipationGetters.MyEventsResponses
        ]
    );
    const elmtData = computed<Array<timelineElmtModel>>(() =>
      store.getters[
        ParticipationModule.desc + ParticipationGetters.TimelineDataList
      ](
        props.eventHeaders,
        props.eventData,
        userResponse.value,
        props.showWeek * 7,
        props.baseDate
      )
    );

    function stringColor(str: String, alpha: Boolean) {
      var colour = stc(str);
      return colour + (alpha ? "66" : "");
    }

    function localdayjs( date: Date | string) {
      return dayjs( date);
    }

    function updateTheFirstDate(date: Date) {
      context.emit("update:baseDate", date);
    }

    async function onOpenModal(eventid: string) {
      await store.dispatch(
        ParticipationModule.desc +
          ParticipationActions.LoadEventSchedularCountWithMyResponse,
        eventid
      );
      await store.dispatch(
        HosterModule.desc + HosterActions.LoadInvitePerson,
        eventid
      );
      await store.dispatch(
        HosterModule.desc + HosterActions.LoadEventResponse,
        eventid ?? ""
      );
      showModal.value = true;
      modalEventHeaderId.value = eventid;
    }

    return {
      showModal,
      modalEventHeaderId,
      stringColor,
      dayjs,
      updateTheFirstDate,
      onOpenModal,
      rowGroupHeaders,
      rowHeaders,
      elmtData,
    };
  },
});
